// Module
var code = "<span translate=\"{{ ::'summary.info.' + type + '.id'}}\" translate-values=\"{code: code}\"></span> - <a ng-attr-name=\"violationModalLinkScrollTo{{:: index}}\" ng-click=\"scroll('violation' + index)\">{{ ::'summary.info.' + description + '.link' | translate:[(index)] }}</a> ";
// Exports
module.exports = code;